(() => {
  if (window.amaroShell) return;
  window.amaroShell = true;
  const bound = new WeakSet();
  let opener;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-amaro-open-products]');
    const dialog = document.getElementById('AmaroProductsDialog');
    if (!dialog) return;
    if (trigger) {
      event.preventDefault();
      if (dialog.open) return;
      const drawer = document.querySelector('header-drawer-menu.open');
      if (drawer) drawer.closeDrawer();
      opener = trigger;
      if (!bound.has(dialog)) {
        bound.add(dialog);
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.body.classList.remove('amaro-products-open');
          document.querySelectorAll('[data-amaro-open-products]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
          const returnTarget = opener?.closest('header-drawer-menu:not(.open)')
            ? document.querySelector('.header-menu-btn') : opener;
          if (returnTarget?.isConnected) returnTarget.focus({ preventScroll: true });
        });
      }
      document.querySelectorAll('[data-amaro-open-products]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('amaro-products-open');
      dialog.showModal();
      return;
    }
    if (event.target.closest('[data-amaro-close-products]')) dialog.close();
    else if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
})();
